import { accountStorageKey } from './accountSessions';
import { hostWebApp } from './hostWebApp';

export const TELEGRAM_TRIAL_LEASE_EVENT = 'zia:telegram-trial-lease';
export const TELEGRAM_TRIAL_URL = 'https://t.me/ZiaWellNavBot/app?startapp=individual_trial';
export interface TelegramTrialStatus {
  active: boolean; used: boolean; canTrial: boolean; alreadyHasAccess: boolean;
  companyPlanRequired: boolean; expiresAt: string | null; serverNow: string;
}
let leaseAccount = '';
let leaseDeadline = 0;

export function hasTelegramTrialLease(): boolean {
  return Boolean(leaseAccount && leaseAccount === accountStorageKey('subscription'));
}
export function telegramTrialRemainingMs(): number {
  return hasTelegramTrialLease() ? Math.max(0, leaseDeadline - performance.now()) : 0;
}
export function clearTelegramTrialLease() {
  leaseAccount = ''; leaseDeadline = 0;
  window.dispatchEvent(new Event(TELEGRAM_TRIAL_LEASE_EVENT));
}
export function updateTelegramTrialLease(data: { accessSource?: string; active?: boolean; trialing?: boolean;
  expiresAt?: string; serverNow?: string }, requestStarted: number, account: string) {
  if (account !== accountStorageKey('subscription')) return;
  if (data.accessSource !== 'telegram_trial') { clearTelegramTrialLease(); return; }
  leaseAccount = account;
  const remaining = Date.parse(data.expiresAt || '') - Date.parse(data.serverNow || '');
  // Never persist a trial or use the phone clock. Refresh at least once a minute,
  // and subtract the request time so a slow response cannot extend the deadline.
  leaseDeadline = (data.active || data.trialing) && Number.isFinite(remaining) && remaining > 0
    ? requestStarted + Math.min(remaining, 60000) : 0;
  window.dispatchEvent(new Event(TELEGRAM_TRIAL_LEASE_EVENT));
}

export async function getTelegramTrialStatus(start = false): Promise<TelegramTrialStatus> {
  const account = accountStorageKey('subscription');
  const response = await fetch('/api/subscription/telegram-trial', {
    method: start ? 'POST' : 'GET',
    headers: { 'X-Telegram-Init-Data': hostWebApp.getInitData() },
    cache: 'no-store', signal: AbortSignal.timeout(15000),
  });
  const data = await response.json();
  if (account !== accountStorageKey('subscription')) throw new Error('Account changed. Please retry.');
  if (!response.ok) throw new Error(data.error || 'Could not verify your free week. Please retry.');
  return data as TelegramTrialStatus;
}
